import { createKeyDate } from './create'
import { deleteKeyDate } from './delete'
import { updateKeyDate } from './update'

export const keyDates = {
  create: createKeyDate,
  delete: deleteKeyDate,
  update: updateKeyDate,
}
